import { sidebarTypes } from '../types';

const initialState = {
    open: false,
};

export const sidebar = (state = initialState, action) => {
    switch (action.type) {
        case sidebarTypes.OPEN:
            return { ...state, open: true };
        case sidebarTypes.CLOSE:
            return { ...state, open: false };
        case sidebarTypes.TOGGLE:
            return { ...state, open: !state.open };
        default:
            return state;
    }
};
